<div class="t-widget profile-container">
  <img class="main-icon" src="assets\img\pref.svg" />

  <div class="pref-list">
    <div *ngFor="let pref of data" class="pref">
      <img
        *ngIf="pref.prefType == 'RX_OPT' && pref.iconKey"
        class="pref-icon"
        [src]="getIcon(pref.iconKey)"
        pTooltip="{{ pref.opt.text }}: {{ pref.optValue.text }}"
        tooltipPosition="bottom"
      />

      <img
        *ngIf="pref.prefType == 'RX_OPT' && !pref.iconKey"
        class="pref-icon"
        [src]="getIcon('gen_pref.svg')"
        pTooltip="{{ pref.opt.text }} {{ pref.optValue.text }}"
        tooltipPosition="bottom"
      />

      <img
        *ngIf="pref.prefType == 'NOTE' && pref.noteLineType == 'FIXED'"
        class="pref-icon"
        [src]="getIcon('note_fixed.svg')"
        pTooltip="{{ pref.note }}"
        tooltipPosition="bottom"
      />

      <img
        *ngIf="pref.prefType == 'NOTE' && pref.noteLineType == 'REMOVABLE'"
        class="pref-icon"
        [src]="getIcon('note_removable.svg')"
        pTooltip="{{ pref.note }}"
        tooltipPosition="bottom"
      />

      <img
        *ngIf="pref.prefType == 'PERSONAL_GUIDANCE'"
        class="pref-icon"
        [src]="getIcon('pg.svg')"
        pTooltip="{{ pref.technician?.text }}"
        tooltipPosition="bottom"
      />

      <img
        *ngIf="pref.prefType == 'AUTO_APPROVE' && !pref.iconKey"
        class="pref-icon"
        [src]="getIcon('tech_issue.svg')"
        pTooltip="{{ pref.techIssue?.text }}"
        tooltipPosition="bottom"
      />

      <img
        *ngIf="pref.prefType == 'AUTO_APPROVE' && pref.iconKey"
        class="pref-icon"
        [src]="getIcon(pref.iconKey)"
        pTooltip="{{ pref.techIssue?.text }}"
        tooltipPosition="bottom"
      />
    </div>
  </div>
</div>
